<script>
import Vue from 'vue'
import NavBar from '@components/nav-bar.vue'
import Breadcrumb from '@components/breadcrumb.vue'
import Error from '@components/error.vue'
import Footer from '@components/footer.vue'
import Modal from '@components/shared/modal.vue'
import FormGenerator from '@components/forms/FormGenerator.vue'

// import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'

import { formattedMoment } from '@utils/helpers.js'

import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

import { uuid } from 'vue-uuid'

import fab from 'vue-fab'

export default {
  components: {
    NavBar,
    Breadcrumb,
    Error,
    Footer,
    Modal,
    'form-generator': FormGenerator,
    DateRangePicker,
    fab,
  },
  props: {
    breadcrumb: {
      type: Array,
      default() {
        return []
      },
    },
    lastUpdated: {
      type: Array,
      default() {
        return []
      },
    },
    error: {
      type: String,
      default() {
        return ''
      },
    },
    paramsSchema: {
      type: Array,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      uuid: uuid.v1(),
      autoApply: true,
      opens: 'left',
      bgColor: '#778899',
      position: 'top-right',

      fabActions: [
        {
          name: 'openParams',
          icon: 'settings',
        },
        {
          name: 'openDatePicker',
          icon: 'date_range',
        },
      ],
    }
  },
  computed: {
    selectedDateRange: {
      get() {
        return this.$store.getters['report/getSelectedDateRange']
      },
      set(payload) {
        this.$store.dispatch('report/SET_SELECTED_DATE_RANGE', payload)
      },
    },
    modalId() {
      return `reportModal_${this.uuid}`
    },
  },
  watch: {
    // $resize: {
    //   immediate: true,
    //   handler(mq){
    //     if(!this.$mq.above(992)){
    //       this.columnDefs.forEach((col, index) => {
    //         if('pinned' in col && index > 0){
    //           col.pinned = false;
    //         }
    //       });
    //       this.resizeHeaders = true;
    //     } else {
    //       this.resizeHeaders = false;
    //     }
    //   }
    // }
  },
  beforeMount() {
    if (this.$mq.above(992)) {
      this.autoApply = true
      this.opens = 'left'
    } else {
      this.autoApply = false
      this.opens = 'center'
    }
  },
  methods: {
    formattedMoment: formattedMoment,
    openParams() {
      this.$bvModal.show(this.modalId)
    },
    clearParams() {
      Vue.set(this, 'params', {})
    },
    toggleDatePicker() {
      // Hack to trick clickAway listener in this plugin
      setTimeout(() => this.$refs.picker.togglePicker(true), 100)
    },
    dateFormat(classes, date) {},
    updateValues(e) {},
    checkOpen(open, toggle) {},
  },
}
</script>

<template>
  <div class="layout layout-nav-side">
    <NavBar />

    <div class="main-container">
      <Breadcrumb>
        <template v-slot:slot3>
          <div class="datepicker-slot">
            <DateRangePicker
              ref="picker"
              v-model="selectedDateRange"
              class="ml-2 date-range"
              :linked-calendars="true"
              :opens="opens"
              :locale-data="{firstDay: 1, format: 'ddmmmyy'}"
              :single-date-picker="false"
              :time-picker="false"
              :time-picker24-hour="true"
              :show-week-numbers="true"
              :show-dropdowns="true"
              :auto-apply="autoApply"
              @update="updateValues"
            >
              <template v-slot:input="picker" style="min-width: 350px;">
                {{ formattedMoment(picker.startDate, 'ddd DDMMMYY') }} -
                {{ formattedMoment(picker.endDate, 'ddd DDMMMYY') }}
              </template>
            </DateRangePicker>
          </div>
          <div v-if="$resize && $mq.above(992)" class="button-slot">
            <button
              class="btn btn-sm ml-1"
              :class="
                Object.keys(params).length > 0 ? 'btn-success' : 'btn-light'
              "
              @click="openParams"
            >
              <b-icon icon="gear-fill"></b-icon>
            </button>
          </div>
        </template>
      </Breadcrumb>

      <slot v-if="!error" />

      <Error v-if="error" :error="error.data" />

      <Footer :last-updated="lastUpdated" />
    </div>

    <Modal :id="modalId" title="Report Parameters" @clear="clearParams">
      <form-generator v-model="params" :schema="paramsSchema"></form-generator>
      <!-- <code>{{params}}</code>
      <template slot="default">This is where the parameters will go!</template>-->
    </Modal>

    <fab
      v-if="$resize && !$mq.above(992)"
      :actions="fabActions"
      main-icon="settings"
      icon-size="small"
      :enable-rotation="true"
      @openParams="openParams"
      @openDatePicker="toggleDatePicker"
    ></fab>
  </div>
</template>

<style>
.form-control.reportrange-text {
  border: 0;
  padding: unset;
  height: 23px;
  padding: 0 15px;
  background: #efefef;
  font-weight: 600;
  color: inherit;
  border-radius: 4px;
}
.daterangepicker.opensleft {
  top: 32px !important;
  right: 0 !important;
  left: auto;
}
.daterangepicker td.in-range {
  background-color: #00878f2e;
}
.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: #00878f;
}
</style>
